const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-business-partners'] = {
        c: () => require('partner/modules/dlvry-business-partners/dlvry-business-partners.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-business-partners',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-business-partners'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dlvry-business-partners|dlvry-business-partners'] = {
                c: () => require('partner/modules/dlvry-business-partners/dlvry-business-partners.view.tsx'),
                cn: '__local__-__local__-dlvry-business-partners'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };